import { render, staticRenderFns } from "./productcode_management.vue?vue&type=template&id=069aaf3e&scoped=true&"
import script from "./productcode_management.vue?vue&type=script&lang=js&"
export * from "./productcode_management.vue?vue&type=script&lang=js&"
import style0 from "./productcode_management.vue?vue&type=style&index=0&id=069aaf3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069aaf3e",
  null
  
)

export default component.exports